import { useState } from "react";

// Helper: format phone numbers to consistent "(800) 123-4567" style
const formatPhone = (raw) => {
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 11 && digits[0] === "1") {
    const area = digits.slice(1, 4);
    const prefix = digits.slice(4, 7);
    const line = digits.slice(7, 11);
    return `(${area}) ${prefix}-${line}`;
  }
  if (digits.length === 10) {
    const area = digits.slice(0, 3);
    const prefix = digits.slice(3, 6);
    const line = digits.slice(6, 10);
    return `(${area}) ${prefix}-${line}`;
  }
  return raw;
};

// Complete carrier list from provided content (merged with existing data)
const rawCarrierList = [
  ["Aetna", "1-800-872-3862"],
  ["American Amicable", "1-800-746-1670"],
  ["Americo", "1-800-231-0801"],
  ["Athene", "1-888-266-8489"],
  ["Corebridge", "1-844-452-3832"],
  ["Ethos", "1-888-384-6754"],
  ["F&G", "1-800-445-6758"],
  ["Foresters", "1-800-828-1540"],
  ["John Hancock", "1-877-606-7779"],
  ["Mutual of Omaha", "1-800-775-6000"],
  ["Transamerica", "1-800-797-2643"],
  ["Transamerica FE express", "1-800-453-1448"],
  ["AAA", "1-800-684-4222"],
  ["AARP", "1-800-850-2658"],
  ["Aflac", "1-800-992-3522"],
  ["Allianz Life", "1-800-950-5872"],
  ["American Family Life Insurance", "1-800-692-6326"],
  ["American Fidelity Assurance Company", "1-800-654-8489"],
  ["American Fidelity", "1-800-662-1113"],
  ["American Heritage / Allstate", "1-800-521-3535"],
  ["American Income", "1-800-433-3405"],
  ["American Memorial Life Insurance", "1-800-669-8477"],
  ["American National", "1-800-899-6806"],
  ["Ameritas", "1-800-745-1112"],
  ["Assumption Life", "1-800-455-7337"],
  ["Assurity Life Insurance Company", "1-800-869-0355"],
  ["AXA Equitable", "1-877-222-2144"],
  ["Baltimore Life", "1-800-628-5433"],
  ["Bankers Life", "1-800-283-8011"],
  ["Banner Life Insurance", "1-800-638-8428"],
  ["Bestow Life Insurance", "1-833-300-0603"],
  ["Brighthouse Financial", "1-800-882-1292"],
  ["Cigna", "1-800-997-1654"],
  ["Cincinnati Life Insurance Company", "1-800-783-4479"],
  ["Citizens Life", "1-512-837-7100"],
  ["Colonial Life & Accident Insurance", "1-800-325-4368"],
  ["Colonial Penn", "1-877-877-8052"],
  ["Columbian Financial Group (CFG)", "1-800-423-9765"],
  ["Columbus Life Insurance", "1-800-677-9696"],
  ["Country Financial", "1-866-268-6879"],
  ["CUNA Mutual Group", "1-800-779-5433"],
  ["EMC National Life", "1-800-232-5818"],
  ["Equitable Life", "1-800-777-6510"],
  ["Family Benefit", "1-918-249-2438"],
  ["Family Heritage", "1-440-922-5222"],
  ["Farmers", "1-888-327-6335"],
  ["Fidelity Life", "1-800-369-3990"],
  ["First Penn-Pacific Life Insurance", "1-800-869-5200"],
  ["General Re Life Corporation", "1-203-352-3000"],
  ["Genworth Financial", "1-888-436-9678"],
  ["Gerber Life", "1-800-704-2180"],
  ["Gleaner Life Insurance Society", "1-800-992-1894"],
  ["Global Atlantic", "1-855-887-4487"],
  ["Globe Life", "1-800-831-1200"],
  ["Great American Life Insurance", "1-800-854-3649"],
  ["Great Western", "1-866-689-1404"],
  ["Guardian Life Insurance Company", "1-888-482-7342"],
  ["Guarantee Trust Life Insurance", "1-800-338-7452"],
  ["Haven Life", "1-855-744-2836"],
  ["Illinois Mutual Life Insurance", "1-800-437-7355"],
  ["Jackson National Life Insurance", "1-800-644-4565"],
  ["Kansas City Life Insurance Company", "1-800-821-5529"],
  ["Kemper Life Insurance", "1-800-777-8467"],
  ["Lafayette Life Insurance Company", "1-800-443-8793"],
  ["Liberty Bankers Life Insurance", "1-800-972-6615"],
  ["Liberty Mutual", "1-800-290-8711"],
  ["Liberty National", "1-800-333-0637"],
  ["Lincoln Financial Group", "1-800-487-1485"],
  ["Lincoln Heritage", "1-800-438-7180"],
  ["Life Insurance Company of the Southwest (LSW)", "1-800-732-8939"],
  ["Lumico", "1-866-440-4047"],
  ["ManhattanLife", "1-800-669-9030"],
  ["MassMutual", "1-800-272-2216"],
  ["MetLife", "1-800-638-5000"],
  ["Midland National", "1-800-923-3223"],
  ["Minnesota Life Insurance Company (Securian Financial)", "1-800-820-4205"],
  ["Mutual Trust Life Insurance", "1-800-323-7320"],
  ["Nassau Financial Group", "1-800-541-0171"],
  ["National Life Group", "1-800-732-8939"],
  ["National Western Life Insurance", "1-800-922-9422"],
  ["Nationwide", "1-877-669-6877"],
  ["New York Life", "1-800-225-5695"],
  ["North American Company for Life and Health Insurance", "1-877-872-0757"],
  ["Northwestern Mutual", "1-866-950-4644"],
  ["Occidental / American Amicable", "1-800-736-7311"],
  ["Oxford Life Insurance Company", "1-800-308-2318"],
  ["Pacific Life", "1-800-800-7646"],
  ["Pan-American Life Insurance", "1-877-939-4550"],
  ["Pekin Life Insurance Company", "1-800-322-0160"],
  ["Penn Mutual Life Insurance", "1-800-523-0650"],
  ["Philadelphia American Life Insurance", "1-800-552-7879"],
  ["Pioneer American / American Amicable", "1-800-736-7311"],
  ["Principal Financial Group", "1-800-986-3343"],
  ["Primerica", "1-800-257-4725"],
  ["Protective Life Insurance", "1-800-866-9933"],
  ["Prudential", "1-800-778-2255"],
  ["Reliance Standard Life Insurance", "1-800-351-7500"],
  ["Reliable Life", "1-651-451-0101"],
  ["ReelStar / Voya", "1-877-884-5050"],
  ["Royal Neighbors of America", "1-800-627-4762"],
  ["SBLI (Savings Bank Mutual Life Insurance)", "1-888-630-5000"],
  ["Securian Financial (Minnesota Life)", "1-800-820-4205"],
  ["Security Benefit Life Insurance", "1-800-888-2461"],
  ["Senior Life", "1-229-228-6936"],
  ["Standard Life and Accident Insurance", "1-888-290-1085"],
  ["State Farm", "1-800-782-8332"],
  ["State Life Insurance Company", "1-800-428-2316"],
  ["Sterling Life Insurance Company", "1-800-688-0010"],
  ["Symetra Life Insurance", "1-800-796-3872"],
  ["TIAA-CREF Life Insurance Company", "1-877-694-0305"],
  ["Thrivent Financial for Lutherans", "1-800-847-4836"],
  ["TruStage", "1-855-591-9026"],
  ["Trustmark Benefits", "1-847-615-1500"],
  ["Unified Life Insurance Company", "1-800-237-4463"],
  ["Union Central Life Insurance Company", "1-800-825-1551"],
  ["United American Insurance Company", "1-800-331-2512"],
  ["United Fidelity Life Insurance", "1-800-366-6100"],
  ["United Home Life Insurance", "1-800-428-3001"],
  ["United Life Insurance Company", "1-800-637-6318"],
  ["Unum", "1-866-679-3054"],
  ["USAA Life Insurance", "1-800-531-8722"],
  ["Vantis Life Insurance Company", "1-866-826-8471"],
  ["Washington National", "1-800-525-7662"],
  ["Wellabe", "1-800-733-5454"],
  ["Western & Southern Life", "1-800-926-1993"],
  ["William Penn Life Insurance", "1-800-346-4773"],
  ["WoodmenLife", "1-800-225-3108"],
  ["Zurich American Life Insurance", "1-877-678-7534"],
];

// Build carrier map with formatted phones
const carrierMap = new Map();
for (const [name, phone] of rawCarrierList) {
  carrierMap.set(name, formatPhone(phone));
}

// Define primary carriers (with icons) – keep original 4, update phone from map
const primaryNames = ["Mutual of Omaha", "Aetna", "Americo", "Transamerica"];
const carriers = {
  primary: primaryNames.map((name) => {
    let icon = "shield";
    if (name === "Aetna") icon = "check-shield";
    if (name === "Transamerica") icon = "star";
    return {
      name,
      phone: carrierMap.get(name) || "(800) 000-0000",
      icon,
    };
  }),
  extended: [],
  directory: [],
};

// Build extended list: every carrier from the map that is NOT in primary
const primarySet = new Set(primaryNames);
for (const [name, phone] of carrierMap.entries()) {
  if (!primarySet.has(name)) {
    carriers.extended.push({ name, phone });
  }
}

// Sort extended alphabetically for better readability
carriers.extended.sort((a, b) => a.name.localeCompare(b.name));

// Build unified allCarriers array for search
const allCarriers = [
  ...carriers.primary,
  ...carriers.extended,
  ...carriers.directory.map((name) => ({ name })),
];

const alphabet = ["A", "C", "E", "F", "J", "M", "T"];

const statusChips = [
  "Live Contact Database",
  "Secure Calling Access",
  "Verified Directory",
  "Carrier Lines Online",
];

const toTelHref = (phone) => `tel:${phone.replace(/\D/g, "")}`;

// Icons
const ShieldIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const CheckShieldIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);

const StarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.47 11.47 0 003.58.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.47 11.47 0 00.57 3.58 1 1 0 01-.25 1.01l-2.2 2.2z" />
  </svg>
);

const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

function getIcon(type) {
  if (type === "check-shield") return <CheckShieldIcon />;
  if (type === "star") return <StarIcon />;
  return <ShieldIcon />;
}

// Main Component
export default function CarrierContacts() {
  const [search, setSearch] = useState("");
  const [activeAlpha, setActiveAlpha] = useState(null); // null = no filter

  const filtered = search.trim()
    ? allCarriers.filter((c) => {
        const value = `${c.name} ${c.phone || ""}`.toLowerCase();
        return value.includes(search.toLowerCase());
      })
    : null;

  // Apply alphabetical filter to primary and extended lists (only when search is empty)
  const filteredPrimary = activeAlpha
    ? carriers.primary.filter((c) =>
        c.name.toUpperCase().startsWith(activeAlpha)
      )
    : carriers.primary;

  const filteredExtended = activeAlpha
    ? carriers.extended.filter((c) =>
        c.name.toUpperCase().startsWith(activeAlpha)
      )
    : carriers.extended;

  // Toggle filter: clicking same letter removes filter, clicking new letter sets filter
  const handleAlphaClick = (letter) => {
    setActiveAlpha(activeAlpha === letter ? null : letter);
  };

  return (
    <div
      style={{ fontFamily: "'IBM Plex Mono', 'Courier New', monospace" }}
      className="cc-page min-h-screen text-white"
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@300;400;500;600;700&display=swap');
        .cc-page, .cc-page * { box-sizing: border-box; }
        .cc-page {
          position: relative;
          overflow-x: hidden;
          background:
            radial-gradient(circle at 14% 8%, rgba(0, 221, 255, 0.16), transparent 28%),
            radial-gradient(circle at 88% 16%, rgba(245, 197, 24, 0.12), transparent 28%),
            linear-gradient(145deg, #061014 0%, #0a151b 48%, #050609 100%);
          padding: clamp(18px, 3vw, 44px);
          isolation: isolate;
        }
        .cc-page::before,
        .cc-page::after {
          content: "";
          position: fixed;
          inset: 0;
          pointer-events: none;
          z-index: -1;
        }
        .cc-page::before {
          opacity: 0.24;
          background-image:
            linear-gradient(rgba(75, 224, 255, 0.09) 1px, transparent 1px),
            linear-gradient(90deg, rgba(75, 224, 255, 0.09) 1px, transparent 1px);
          background-size: 44px 44px;
          mask-image: linear-gradient(to bottom, rgba(0,0,0,0.94), rgba(0,0,0,0.18));
          animation: cc-grid-drift 18s linear infinite;
        }
        .cc-page::after {
          opacity: 0.15;
          background:
            linear-gradient(180deg, transparent 0%, rgba(0, 221, 255, 0.12) 48%, transparent 52%),
            radial-gradient(circle at 72% 76%, rgba(0, 221, 255, 0.18), transparent 24%);
          background-size: 100% 280px, 100% 100%;
          animation: cc-scan 8s ease-in-out infinite;
        }
        .cc-shell {
          width: 100%;
          max-width: 1500px;
          margin: 0 auto;
        }
        .cc-hero {
          position: relative;
          overflow: hidden;
          border: 1px solid rgba(75, 224, 255, 0.24);
          border-radius: 20px;
          padding: clamp(24px, 4.2vw, 48px);
          background:
            linear-gradient(135deg, rgba(10, 27, 34, 0.93), rgba(8, 14, 20, 0.72)),
            radial-gradient(circle at 82% 18%, rgba(245, 197, 24, 0.14), transparent 28%);
          box-shadow:
            0 26px 80px rgba(0, 0, 0, 0.38),
            inset 0 1px 0 rgba(255, 255, 255, 0.08),
            0 0 34px rgba(0, 221, 255, 0.08);
          animation: cc-card-in 520ms ease both;
        }
        .cc-hero::before {
          content: "";
          position: absolute;
          inset: -42%;
          background: conic-gradient(from 120deg, transparent, rgba(0, 221, 255, 0.16), transparent, rgba(245, 197, 24, 0.13), transparent);
          opacity: 0.42;
          animation: cc-mesh 14s linear infinite;
        }
        .cc-hero > * { position: relative; z-index: 1; }
        .cc-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 14px;
          color: #f5c518;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.2em;
          text-transform: uppercase;
        }
        .cc-eyebrow span,
        .cc-status-chip span,
        .cc-status-badge::before {
          content: "";
          width: 8px;
          height: 8px;
          border-radius: 999px;
          background: #34f6a5;
          box-shadow: 0 0 14px rgba(52, 246, 165, 0.8);
          animation: cc-pulse 1.9s ease-in-out infinite;
        }
        .cc-hero h1 {
          max-width: 980px;
          margin: 0;
          color: #f8fbff;
          font-size: clamp(31px, 5vw, 68px);
          line-height: 0.96;
          letter-spacing: 0.035em;
          text-transform: uppercase;
          text-shadow: 0 0 34px rgba(0, 221, 255, 0.22);
          animation: cc-title-glow 3.8s ease-in-out infinite;
        }
        .cc-hero p {
          max-width: 760px;
          margin: 16px 0 0;
          color: rgba(224, 239, 255, 0.74);
          font-size: clamp(14px, 1.3vw, 16px);
          line-height: 1.65;
        }
        .cc-status-strip {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 28px;
        }
        .cc-status-chip {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          min-height: 34px;
          padding: 8px 12px;
          border: 1px solid rgba(75, 224, 255, 0.18);
          border-radius: 999px;
          background: rgba(5, 18, 24, 0.66);
          color: rgba(228, 249, 255, 0.78);
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
        }
        .cc-control-panel {
          display: grid;
          gap: 16px;
          margin: clamp(22px, 3vw, 34px) 0;
        }
        .cc-search { position: relative; margin-bottom: 0 !important; }
        .cc-search .search-icon {
          position: absolute;
          left: 18px;
          top: 50%;
          transform: translateY(-50%);
          color: rgba(75, 224, 255, 0.78);
          filter: drop-shadow(0 0 10px rgba(75, 224, 255, 0.36));
          z-index: 1;
        }
        .cc-clear-btn {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          width: 34px;
          height: 34px;
          border: 1px solid rgba(245, 197, 24, 0.24);
          border-radius: 999px;
          background: rgba(245, 197, 24, 0.08);
          color: #f5c518;
          cursor: pointer;
          transition: transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease;
        }
        .cc-clear-btn:hover {
          transform: translateY(-50%) scale(1.04);
          border-color: rgba(245, 197, 24, 0.62);
          box-shadow: 0 0 18px rgba(245, 197, 24, 0.18);
        }

        .primary-card {
          position: relative;
          overflow: hidden;
          background: linear-gradient(145deg, rgba(13, 30, 39, 0.86), rgba(6, 12, 17, 0.78));
          border: 1px solid rgba(75, 224, 255, 0.18);
          box-shadow: 0 18px 48px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.06);
          transition: transform 0.22s, border-color 0.22s, box-shadow 0.22s;
          animation: cc-card-in 520ms ease both;
        }
        .primary-card:hover {
          border-color: rgba(75, 224, 255, 0.48);
          transform: translateY(-5px);
          box-shadow: 0 24px 70px rgba(0,0,0,0.36), 0 0 28px rgba(75,224,255,0.12), inset 0 1px 0 rgba(255,255,255,0.09);
        }
        .primary-card::after,
        .extended-card::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(110deg, transparent, rgba(255,255,255,0.08), transparent);
          transform: translateX(-120%);
          transition: transform 420ms ease;
          pointer-events: none;
        }
        .primary-card:hover::after,
        .extended-card:hover::after {
          transform: translateX(120%);
        }
        .call-btn {
          background: linear-gradient(135deg, #00d9ff, #1677ff);
          color: #031015;
          box-shadow: 0 14px 34px rgba(0, 217, 255, 0.18), inset 0 1px 0 rgba(255,255,255,0.24);
          transition: background 0.15s, transform 0.1s, box-shadow 0.18s, filter 0.18s;
        }
        .call-btn:hover {
          filter: brightness(1.08);
          transform: scale(1.02);
          box-shadow: 0 18px 42px rgba(0, 217, 255, 0.28), 0 0 24px rgba(0, 217, 255, 0.18);
        }
        .call-btn:active {
          transform: scale(0.98);
        }
        .extended-card {
          position: relative;
          overflow: hidden;
          background: linear-gradient(145deg, rgba(10, 23, 30, 0.78), rgba(5, 10, 14, 0.78));
          border: 1px solid rgba(75, 224, 255, 0.14);
          transition: transform 0.22s, border-color 0.22s, box-shadow 0.22s;
          animation: cc-card-in 520ms ease both;
        }
        .extended-card:hover {
          transform: translateY(-4px);
          border-color: rgba(75, 224, 255, 0.42);
          box-shadow: 0 18px 52px rgba(0,0,0,0.32), 0 0 24px rgba(75,224,255,0.1);
        }
        .call-line-btn {
          background: rgba(0, 217, 255, 0.08);
          border: 1px solid rgba(0, 217, 255, 0.24);
          color: rgba(231, 250, 255, 0.82);
          font-size: 10px;
          letter-spacing: 0.12em;
          transition: border-color 0.2s, color 0.2s, transform 0.18s, box-shadow 0.18s;
        }
        .call-line-btn:hover {
          border-color: rgba(0, 217, 255, 0.68);
          color: #ffffff;
          transform: translateY(-2px);
          box-shadow: 0 0 18px rgba(0, 217, 255, 0.16);
        }
        .alpha-btn {
          background: rgba(6, 18, 24, 0.7);
          border: 1px solid rgba(75, 224, 255, 0.15);
          color: rgba(219, 244, 255, 0.62);
          min-width: 42px;
          height: 36px;
          padding: 0 14px;
          border-radius: 999px !important;
          font-size: 11px;
          letter-spacing: 0.1em;
          transition: all 0.18s;
        }
        .alpha-btn:hover {
          transform: translateY(-2px);
          border-color: rgba(75, 224, 255, 0.58);
          color: #e9fbff;
          box-shadow: 0 0 20px rgba(75, 224, 255, 0.16);
        }
        .alpha-btn.active {
          background: linear-gradient(135deg, #f5c518, #b9902b);
          border: 1px solid rgba(245, 197, 24, 0.78);
          color: #091015;
          box-shadow: 0 0 24px rgba(245, 197, 24, 0.26);
          animation: cc-gold-ring 2.2s ease-in-out infinite;
        }
        .search-input {
          min-height: 58px;
          background: rgba(4, 12, 17, 0.72);
          border: 1px solid rgba(75, 224, 255, 0.2);
          border-radius: 16px !important;
          color: #eef8ff;
          transition: border-color 0.22s, box-shadow 0.22s, background 0.22s;
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.05), 0 14px 44px rgba(0,0,0,0.24);
        }
        .search-input:focus {
          outline: none;
          border-color: rgba(75, 224, 255, 0.62);
          background: rgba(4, 16, 22, 0.9);
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.08), 0 0 0 4px rgba(75,224,255,0.08), 0 0 36px rgba(75,224,255,0.12);
        }
        .search-input::placeholder {
          color: rgba(217, 234, 245, 0.42);
          letter-spacing: 0.08em;
        }
        .dir-card {
          background: #0d0d0d;
          border: 1px solid #181818;
          transition: border-color 0.2s;
        }
        .dir-card:hover {
          border-color: #2a2a2a;
        }
        .section-line {
          flex: 1;
          height: 1px;
          background: linear-gradient(to right, rgba(75,224,255,0.22), transparent);
        }
        .icon-badge {
          display: grid;
          place-items: center;
          width: 44px;
          height: 44px;
          border: 1px solid rgba(75, 224, 255, 0.34);
          border-radius: 14px;
          color: #eafbff;
          background: radial-gradient(circle at 50% 20%, rgba(75,224,255,0.25), transparent 54%), rgba(0,221,255,0.08);
          box-shadow: 0 0 24px rgba(75,224,255,0.14), inset 0 0 18px rgba(75,224,255,0.08);
        }
        .cc-status-badge {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          color: #34f6a5;
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          margin-bottom: 12px;
        }
        .cc-section-label {
          color: rgba(228, 249, 255, 0.62) !important;
        }
        .cc-primary-grid {
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)) !important;
        }
        .cc-extended-grid {
          grid-template-columns: repeat(auto-fit, minmax(235px, 1fr)) !important;
        }
        @keyframes cc-card-in {
          from { opacity: 0; transform: translateY(14px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes cc-grid-drift {
          from { background-position: 0 0; }
          to { background-position: 44px 44px; }
        }
        @keyframes cc-scan {
          0%, 100% { background-position: 0 -280px, 0 0; }
          50% { background-position: 0 100vh, 0 0; }
        }
        @keyframes cc-mesh {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes cc-pulse {
          0%, 100% { opacity: 0.72; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.16); }
        }
        @keyframes cc-title-glow {
          0%, 100% { text-shadow: 0 0 26px rgba(0, 221, 255, 0.18); }
          50% { text-shadow: 0 0 42px rgba(0, 221, 255, 0.32); }
        }
        @keyframes cc-gold-ring {
          0%, 100% { box-shadow: 0 0 18px rgba(245, 197, 24, 0.18); }
          50% { box-shadow: 0 0 30px rgba(245, 197, 24, 0.34); }
        }
        @media (max-width: 560px) {
          .cc-page { padding: 18px 14px 28px; }
          .cc-hero { border-radius: 16px; padding: 22px 16px; }
          .cc-status-chip { width: 100%; }
          .cc-primary-grid,
          .cc-extended-grid,
          .cc-results-grid {
            grid-template-columns: 1fr !important;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .cc-page::before,
          .cc-page::after,
          .cc-hero::before,
          .cc-eyebrow span,
          .cc-status-chip span,
          .cc-status-badge::before,
          .alpha-btn.active,
          .primary-card,
          .extended-card {
            animation: none !important;
          }
          .primary-card,
          .extended-card,
          .call-btn,
          .call-line-btn,
          .alpha-btn,
          .search-input {
            transition: none !important;
          }
        }
      `}</style>

      <main className="cc-shell">
        <section className="cc-hero" aria-labelledby="carrier-contact-title">
          <div className="cc-eyebrow">
            <span />
            Agent Call Routing Core
          </div>
          <h1 id="carrier-contact-title">
            Carrier Communication Command Center
          </h1>
          <p>Verified carrier support lines and contact access for agents.</p>
          <div className="cc-status-strip">
            {statusChips.map((chip) => (
              <span className="cc-status-chip" key={chip}>
                <span />
                {chip}
              </span>
            ))}
          </div>
        </section>

        <section className="cc-control-panel" aria-label="Carrier contact filters">
          <div className="cc-search relative">
            <span className="search-icon">
              <SearchIcon />
            </span>
            <input
              type="text"
              className="search-input w-full pl-12 pr-14 py-3 text-xs tracking-widest rounded"
              placeholder="Search carriers, phone numbers, departments..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              aria-label="Search carriers, phone numbers, departments"
            />
            {search && (
              <button
                type="button"
                className="cc-clear-btn"
                onClick={() => setSearch("")}
                aria-label="Clear search"
              >
                X
              </button>
            )}
          </div>

          <div className="cc-alpha-row flex flex-wrap gap-2">
            {alphabet.map((l) => (
              <button
                key={l}
                onClick={() => handleAlphaClick(l)}
                className={`alpha-btn rounded font-medium ${
                  activeAlpha === l ? "active" : ""
                }`}
              >
                {l}
              </button>
            ))}
          </div>
        </section>

      {/* Search Results */}
      {filtered ? (
        <div>
          <div className="flex items-center gap-4 mb-6">
            <span className="cc-section-label text-[10px] tracking-[0.2em]">
              SEARCH RESULTS ({filtered.length})
            </span>
            <div className="section-line" />
          </div>
          <div className="cc-results-grid cc-extended-grid grid gap-4">
            {filtered.map((c, i) =>
              c.phone ? (
                <div
                  key={i}
                  className="primary-card rounded-lg p-5"
                  style={{ animationDelay: `${Math.min(i, 18) * 28}ms` }}
                >
                  <span className="cc-status-badge">Verified Line</span>
                  <p className="text-sm font-semibold mb-1 leading-snug">{c.name}</p>
                  <p className="text-base font-medium text-white mb-3">{c.phone}</p>
                  <button
                    className="call-btn w-full py-2 rounded text-[10px] font-bold tracking-widest flex items-center justify-center gap-2"
                    onClick={() => window.location.assign(toTelHref(c.phone))}
                  >
                    <PhoneIcon /> Call Carrier
                  </button>
                </div>
              ) : (
                <div key={i} className="dir-card rounded p-4 flex items-center">
                  <span className="text-[10px] tracking-[0.15em] text-[#555] mr-2">CARRIER</span>
                  <span className="text-sm font-medium">{c.name}</span>
                </div>
              )
            )}
          </div>
        </div>
      ) : (
        <>
          {/* Primary Carriers */}
          <div className="mb-10">
            <div className="flex items-center gap-4 mb-6">
              <div className="section-line rotate-180" />
              <span className="text-[10px] tracking-[0.2em] text-[#555] whitespace-nowrap">
                PRIMARY CARRIERS
              </span>
              <div className="w-8 h-px bg-[#1a1a1a]" />
            </div>
            <div className="cc-primary-grid grid gap-4">
              {filteredPrimary.map((carrier, i) => (
                <div
                  key={i}
                  className="primary-card rounded-lg p-5"
                  style={{ animationDelay: `${Math.min(i, 18) * 36}ms` }}
                >
                  <div className="flex items-start justify-between mb-3">
                    <h3 className="text-sm font-semibold leading-snug">{carrier.name}</h3>
                    <span className="icon-badge ml-2 mt-0.5 flex-shrink-0">
                      {getIcon(carrier.icon)}
                    </span>
                  </div>
                  <span className="cc-status-badge">Carrier Line Online</span>
                  <p className="text-xl font-medium text-white mb-4 tracking-tight">
                    {carrier.phone}
                  </p>
                  <button
                    className="call-btn w-full py-2.5 rounded text-[10px] font-bold tracking-widest flex items-center justify-center gap-2"
                    onClick={() => window.location.assign(toTelHref(carrier.phone))}
                  >
                    <PhoneIcon /> Call Carrier
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Extended Directory */}
          <div className="mb-10">
            <div className="flex items-center gap-4 mb-6">
              <div className="section-line rotate-180" />
              <span className="text-[10px] tracking-[0.2em] text-[#555] whitespace-nowrap">
                EXTENDED DIRECTORY
              </span>
              <div className="w-8 h-px bg-[#1a1a1a]" />
            </div>
            <div className="cc-extended-grid grid gap-3">
              {filteredExtended.map((carrier, i) => (
                <div
                  key={i}
                  className="extended-card rounded-lg p-5"
                  style={{ animationDelay: `${Math.min(i, 18) * 24}ms` }}
                >
                  <span className="cc-status-badge">Verified</span>
                  <h3 className="text-sm font-semibold mb-1">{carrier.name}</h3>
                  <p className="text-base font-medium text-white mb-4 tracking-tight">
                    {carrier.phone}
                  </p>
                  <button
                    className="call-line-btn w-full py-2 rounded tracking-widest"
                    onClick={() => window.location.assign(toTelHref(carrier.phone))}
                  >
                    Call Carrier
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Carrier Directory (empty because all carriers have numbers) */}
          <div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
              {carriers.directory.map((name, i) => (
                <div key={i} className="dir-card rounded px-3 py-4 cursor-pointer">
                  <p className="text-[8px] tracking-[0.2em] text-[#333] mb-1">CARRIER</p>
                  <p className="text-xs font-medium text-[#ccc]">{name}</p>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      </main>
    </div>
  );
}








// import { useState } from "react";

// const carriers = {
//   primary: [
//     { name: "Mutual of Omaha", phone: "(800) 775-6000", icon: "shield" },
//     { name: "Aetna", phone: "(800) 264-4000", icon: "check-shield" },
//     { name: "Americo", phone: "(800) 231-0801", icon: "shield" },
//     { name: "Transamerica", phone: "(800) 851-9777", icon: "star" },
//   ],
//   extended: [
//     { name: "AARP", phone: "(800) 523-5800" },
//     { name: "Allianz", phone: "(800) 950-5872" },
//     { name: "MetLife", phone: "(800) 638-5433" },
//     { name: "Globe Life", phone: "(800) 654-5433" },
//   ],
//   directory: [
//     "Assurity",
//     "Aflac",
//     "Bankers Life",
//     "Colonial Penn",
//     "Zurich",
//     "Wellabe",
//   ],
// };

// const allCarriers = [
//   ...carriers.primary,
//   ...carriers.extended,
//   ...carriers.directory.map((name) => ({ name })),
// ];

// const alphabet = ["A", "C", "E", "F", "J", "M", "T"];

// const ShieldIcon = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
//     <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
//   </svg>
// );

// const CheckShieldIcon = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
//     <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
//     <polyline points="9 12 11 14 15 10" />
//   </svg>
// );

// const StarIcon = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
//     <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
//   </svg>
// );

// const PhoneIcon = () => (
//   <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
//     <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24 11.47 11.47 0 003.58.57 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.47 11.47 0 00.57 3.58 1 1 0 01-.25 1.01l-2.2 2.2z" />
//   </svg>
// );

// const SearchIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <circle cx="11" cy="11" r="8" />
//     <line x1="21" y1="21" x2="16.65" y2="16.65" />
//   </svg>
// );

// function getIcon(type) {
//   if (type === "check-shield") return <CheckShieldIcon />;
//   if (type === "star") return <StarIcon />;
//   return <ShieldIcon />;
// }

// export default function CarrierContacts() {
//   const [search, setSearch] = useState("");
//   const [activeAlpha, setActiveAlpha] = useState("A");

//   const filtered = search.trim()
//     ? allCarriers.filter((c) =>
//         c.name.toLowerCase().includes(search.toLowerCase())
//       )
//     : null;

//   return (
//     <div
//       style={{ fontFamily: "'IBM Plex Mono', 'Courier New', monospace" }}
//       className="min-h-screen bg-[#0a0a0a] text-white px-6 py-8"
//     >
//       {/* Import font */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@300;400;500;600;700&display=swap');

//         .primary-card {
//           background: linear-gradient(145deg, #141414 0%, #0f0f0f 100%);
//           border: 1px solid #1f1f1f;
//           transition: border-color 0.2s, transform 0.2s;
//         }
//         .primary-card:hover {
//           border-color: #f5c518;
//           transform: translateY(-2px);
//         }
//         .call-btn {
//           background: #f5c518;
//           color: #000;
//           transition: background 0.15s, transform 0.1s;
//         }
//         .call-btn:hover {
//           background: #ffd93d;
//           transform: scale(1.02);
//         }
//         .call-btn:active {
//           transform: scale(0.98);
//         }
//         .extended-card {
//           background: #0d0d0d;
//           border: 1px solid #1a1a1a;
//           transition: border-color 0.2s;
//         }
//         .extended-card:hover {
//           border-color: #333;
//         }
//         .call-line-btn {
//           background: transparent;
//           border: 1px solid #2a2a2a;
//           color: #888;
//           font-size: 10px;
//           letter-spacing: 0.12em;
//           transition: border-color 0.2s, color 0.2s;
//         }
//         .call-line-btn:hover {
//           border-color: #f5c518;
//           color: #f5c518;
//         }
//         .alpha-btn {
//           background: transparent;
//           border: 1px solid #222;
//           color: #666;
//           width: 36px;
//           height: 36px;
//           font-size: 11px;
//           letter-spacing: 0.1em;
//           transition: all 0.15s;
//         }
//         .alpha-btn:hover {
//           border-color: #444;
//           color: #ccc;
//         }
//         .alpha-btn.active {
//           background: transparent;
//           border: 1px solid #f5c518;
//           color: #f5c518;
//         }
//         .search-input {
//           background: #111;
//           border: 1px solid #1f1f1f;
//           color: #ccc;
//           transition: border-color 0.2s;
//         }
//         .search-input:focus {
//           outline: none;
//           border-color: #f5c518;
//         }
//         .search-input::placeholder {
//           color: #3a3a3a;
//           letter-spacing: 0.08em;
//         }
//         .dir-card {
//           background: #0d0d0d;
//           border: 1px solid #181818;
//           transition: border-color 0.2s;
//         }
//         .dir-card:hover {
//           border-color: #2a2a2a;
//         }
//         .section-line {
//           flex: 1;
//           height: 1px;
//           background: linear-gradient(to right, #1a1a1a, transparent);
//         }
//         .icon-badge {
//           color: #f5c518;
//           opacity: 0.7;
//         }
//       `}</style>

//       {/* Header */}
//       <div className="mb-8">
//         <h1
//           className="text-xl font-semibold tracking-[0.18em] mb-1"
//           style={{ color: "#f5c518" }}
//         >
//           CARRIER CONTACT DIRECTORY
//         </h1>
//         <p className="text-[10px] tracking-[0.22em]" style={{ color: "#2a7a6a" }}>
//           INTERNAL_AGENT_ACCESS // VERIFIED_CARRIER_DATABASE
//         </p>
//       </div>

//       {/* Search */}
//       <div className="relative mb-8">
//         <span className="absolute left-4 top-1/2 -translate-y-1/2 text-[#3a3a3a]">
//           <SearchIcon />
//         </span>
//         <input
//           type="text"
//           className="search-input w-full pl-10 pr-4 py-3 text-xs tracking-widest rounded"
//           placeholder="SEARCH_CARRIER_DATABASE..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//       </div>

//       {/* Alpha Filter */}
//       <div className="flex gap-2 mb-10">
//         {alphabet.map((l) => (
//           <button
//             key={l}
//             onClick={() => setActiveAlpha(l)}
//             className={`alpha-btn rounded font-medium ${activeAlpha === l ? "active" : ""}`}
//           >
//             {l}
//           </button>
//         ))}
//       </div>

//       {/* Search Results */}
//       {filtered ? (
//         <div>
//           <div className="flex items-center gap-4 mb-6">
//             <span className="text-[10px] tracking-[0.2em] text-[#555]">
//               SEARCH_RESULTS ({filtered.length})
//             </span>
//             <div className="section-line" />
//           </div>
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//             {filtered.map((c, i) =>
//               c.phone ? (
//                 <div key={i} className="primary-card rounded-lg p-5">
//                   <p className="text-sm font-semibold mb-1 leading-snug">{c.name}</p>
//                   <p className="text-[9px] tracking-widest text-[#444] mb-1">SUPPORT LINE</p>
//                   <p className="text-base font-medium text-white mb-3">{c.phone}</p>
//                   <button className="call-btn w-full py-2 rounded text-[10px] font-bold tracking-widest flex items-center justify-center gap-2">
//                     <PhoneIcon /> CALL CARRIER
//                   </button>
//                 </div>
//               ) : (
//                 <div key={i} className="dir-card rounded p-4 flex items-center">
//                   <span className="text-[10px] tracking-[0.15em] text-[#555] mr-2">CARRIER</span>
//                   <span className="text-sm font-medium">{c.name}</span>
//                 </div>
//               )
//             )}
//           </div>
//         </div>
//       ) : (
//         <>
//           {/* Primary Carriers */}
//           <div className="mb-10">
//             <div className="flex items-center gap-4 mb-6">
//               <div className="section-line rotate-180" />
//               <span className="text-[10px] tracking-[0.2em] text-[#555] whitespace-nowrap">
//                 PRIMARY_CARRIERS
//               </span>
//               <div className="w-8 h-px bg-[#1a1a1a]" />
//             </div>
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//               {carriers.primary.map((carrier, i) => (
//                 <div key={i} className="primary-card rounded-lg p-5">
//                   <div className="flex items-start justify-between mb-3">
//                     <h3 className="text-sm font-semibold leading-snug">{carrier.name}</h3>
//                     <span className="icon-badge ml-2 mt-0.5 flex-shrink-0">
//                       {getIcon(carrier.icon)}
//                     </span>
//                   </div>
//                   <p className="text-[9px] tracking-[0.18em] text-[#444] mb-1">SUPPORT LINE</p>
//                   <p className="text-xl font-medium text-white mb-4 tracking-tight">
//                     {carrier.phone}
//                   </p>
//                   <button className="call-btn w-full py-2.5 rounded text-[10px] font-bold tracking-widest flex items-center justify-center gap-2">
//                     <PhoneIcon /> CALL CARRIER
//                   </button>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Extended Directory */}
//           <div className="mb-10">
//             <div className="flex items-center gap-4 mb-6">
//               <div className="section-line rotate-180" />
//               <span className="text-[10px] tracking-[0.2em] text-[#555] whitespace-nowrap">
//                 EXTENDED_DIRECTORY
//               </span>
//               <div className="w-8 h-px bg-[#1a1a1a]" />
//             </div>
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
//               {carriers.extended.map((carrier, i) => (
//                 <div key={i} className="extended-card rounded-lg p-5">
//                   <h3 className="text-sm font-semibold mb-1">{carrier.name}</h3>
//                   <p className="text-[9px] tracking-[0.18em] text-[#444] mb-1">SUPPORT</p>
//                   <p className="text-base font-medium text-white mb-4 tracking-tight">
//                     {carrier.phone}
//                   </p>
//                   <button className="call-line-btn w-full py-2 rounded tracking-widest uppercase">
//                     Call Line
//                   </button>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Carrier Directory (small tiles) */}
//           <div>
//             <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2">
//               {carriers.directory.map((name, i) => (
//                 <div
//                   key={i}
//                   className="dir-card rounded px-3 py-4 cursor-pointer"
//                 >
//                   <p className="text-[8px] tracking-[0.2em] text-[#333] mb-1">CARRIER</p>
//                   <p className="text-xs font-medium text-[#ccc]">{name}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }
